export { compareNullableNumbers as comparePnfNumbers, NULLABLE_NUMBER_OPERATORS as PNF_NUMBER_OPERATORS } from "../tableConfig";

export interface RecostPnfTotals {
    totalPnfCountControl: number | null;
    totalPnfCountCandidate: number | null;
    pnfNetChange: number | null;
}

/** Returns a finite, non-negative count; missing or invalid values stay unknown. */
export function pnfCount(value: unknown): number | null {
    return typeof value === "number" && Number.isFinite(value) && value >= 0 ? value : null;
}

function totalPnf(counts: unknown[]): number | null {
    const values = counts.map(pnfCount);
    return values.every((value) => value !== null)
        ? (values as number[]).reduce((total, value) => total + value, 0)
        : null;
}

function pnfTotals(control: unknown[], candidate: unknown[]): RecostPnfTotals {
    const totalPnfCountControl = totalPnf(control);
    const totalPnfCountCandidate = totalPnf(candidate);
    return {
        totalPnfCountControl,
        totalPnfCountCandidate,
        pnfNetChange: totalPnfCountControl !== null && totalPnfCountCandidate !== null
            ? totalPnfCountCandidate - totalPnfCountControl
            : null,
    };
}

export function mapPnfTotals(row: {
    onZonePnfFailureCountControl?: number | null;
    onZonePnfFailureCountExperiment?: number | null;
    stemPnfFailureCountControl?: number | null;
    stemPnfFailureCount?: number | null;
}): RecostPnfTotals {
    // Reported rollups can omit missing station measurements; numeric values do not prove completeness.
    return pnfTotals(
        [row.onZonePnfFailureCountControl, row.stemPnfFailureCountControl],
        [row.onZonePnfFailureCountExperiment, row.stemPnfFailureCount]
    );
}

export function stationPnfTotals(row: {
    on_zone_pnf_failure_control_count?: number | null;
    on_zone_pnf_failure_experiment_count?: number | null;
    stem_in_pnf_failure_control_count?: number | null;
    stem_in_pnf_failure_experiment_count?: number | null;
    stem_out_pnf_failure_control_count?: number | null;
    stem_out_pnf_failure_experiment_count?: number | null;
}): RecostPnfTotals {
    return pnfTotals(
        [row.on_zone_pnf_failure_control_count, row.stem_in_pnf_failure_control_count,
            row.stem_out_pnf_failure_control_count],
        [row.on_zone_pnf_failure_experiment_count, row.stem_in_pnf_failure_experiment_count,
            row.stem_out_pnf_failure_experiment_count]
    );
}
